/** A zeroed buffer of the same texel kind as some pixels, for a copy or a scratch row. */
/**
 * A zeroed buffer of `length` texels, of the kind `pixels` holds.
 *
 * @canonical A buffer of the same texel kind as some pixels
 */
export function emptyLike(pixels, length) {
    if (pixels instanceof Float32Array)
        return new Float32Array(length);
    if (pixels instanceof Uint16Array)
        return new Uint16Array(length);
    return new Uint8Array(length);
}
/**
 * Whether `pixels` already has the texel kind `emptyLike` would give it, so a copy can share them.
 *
 * @canonical A buffer of the same texel kind as some pixels
 */
export function isPlainPixels(pixels) {
    return !(pixels instanceof Uint8ClampedArray);
}
//# sourceMappingURL=emptyLike.js.map